/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */


export function soundNotification(audio: string): { play: () => void } {
    return {
        play: () => {
            if (typeof window !== 'undefined') {
                const audioElement: HTMLAudioElement = new Audio(audio);
                audioElement.currentTime = 0;
                audioElement.play();
            }
        }
    };
}